import { z } from 'zod';
export const EventStatusSchema = z.enum(['draft', 'published', 'archived']);
export const PhotoAlbumModeSchema = z.enum(['admin_only', 'moderated', 'open_with_reports']);
export const EventSchema = z.object({
    id: z.string().uuid(),
    orgId: z.string().uuid(),
    slug: z.string(),
    name: z.string(),
    description: z.string(),
    startAt: z.string(), // ISO; client-side parsed to Date
    endAt: z.string(),
    timezone: z.string(),
    location: z.string(),
    coverImagePath: z.string().nullable(),
    photoAlbumMode: PhotoAlbumModeSchema,
    status: EventStatusSchema,
    themeId: z.string().uuid().nullable(),
});
export const CreateEventRequestSchema = z.object({
    orgId: z.string().uuid(),
    name: z.string().min(1).max(200),
    slug: z.string().min(2).max(80).optional(),
    description: z.string().max(5000).optional(),
    startAt: z.string(),
    endAt: z.string(),
    timezone: z.string().min(1),
    location: z.string().max(500).optional(),
    photoAlbumMode: PhotoAlbumModeSchema.optional(),
});
export const PatchEventRequestSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(5000).optional(),
    startAt: z.string().optional(),
    endAt: z.string().optional(),
    timezone: z.string().min(1).optional(),
    location: z.string().max(500).optional(),
    photoAlbumMode: PhotoAlbumModeSchema.optional(),
    coverImagePath: z.string().nullable().optional(),
});
//# sourceMappingURL=events.js.map